// extracted by mini-css-extract-plugin
module.exports = {"table":"fpYwuK00gZ1oNenhiyFKs","statusLabel":"-LG6n6VKu_38bZQX2BHs0"};